var Chat = function() {
    return {
        init: function() {
            Chat.rowClick();
            Generic.init_popovers();
            if (typeof MatchesTable !== 'undefined') {
                MatchesTable.match_filter = 'recent';
                MatchesTable.applyAllFilters();
                setTimeout(Chat.matchesRefreshLoop, 20 * 1000);
            }
        },
        matchesRefresh: function() {
            return Ajax.getLive(
                'live',
                0,
                0,
                (res) => {
                    $('#results').html(res['html']);
                    Chat.rowClick();
                    MatchesTable.applyAllFilters();
                    if (!Generic.mobile) {
                        Generic.init_popovers();
                    }
                });
        },
        matchesRefreshLoop: function() {
            Chat.matchesRefresh().finally(function() {
                setTimeout(Chat.matchesRefreshLoop, 20 * 1000);
            });
        },
        rowClick: function() {
            // in mobile chat page, clicking on the livescore row takes you to first link
            if (!Generic.mobile) {
                return;
            }
            $(document).on('click', 'tr.ii__match_row', function(e){
                e.stopPropagation();
                e.preventDefault();
                top.location.href = $(this).find('a').first().attr('href');
            });
        }
    };
}();



